import PropTypes from 'prop-types'

import { useIntl } from 'react-intl'

const DeleteWarningMessage = ({
  relatedCampaigns,
  userLists,
  currentList,
  sourceName
}) => {
  const intl = useIntl()

  // Se la Source è presente in una campagne
  const campaignsNotInCurrentList = relatedCampaigns.Items.filter(
    (campaign) => campaign.IdList !== currentList
  )

  const campaignsNotInUserLists = campaignsNotInCurrentList.filter(
    (el) => !userLists.Items.includes(el)
  )

  const campaignsInUserLists = campaignsNotInCurrentList.filter((el) =>
    userLists.Items.includes(el)
  )

  const userListsInCampaigns = userLists.Items.filter((el) =>
    campaignsNotInCurrentList.includes(el)
  )

  const campaignsNames = (
    <>
      <br />
      {relatedCampaigns.Items.map((el, i) => (
        <span key={i}>
          <br />
          {el.Name}
        </span>
      ))}
    </>
  )

  return (
    <div>
      {campaignsNotInCurrentList.length > 0 && (
        <>
          {campaignsNotInUserLists.length > 0 && // Mostra messaggio di errore se: associato a più campagne esterne alla Lista corrente e non presenti in UserList
            intl.formatMessage(
              { id: 'Load.ContentsSouces.DeleteSourceSharedError' },
              {
                strong: (str) => <strong>{str}</strong>,
                NAMESRC: sourceName
              }
            )}
          {campaignsInUserLists.length > 0 && ( // Mostra messaggio di errore se: associato a campagne esterne alla Lista corrente e presenti in UserList
            <>
              {intl.formatMessage(
                {
                  id: 'Load.ContentsSouces.DeleteSourceSharedErrorOtherVisibleList'
                },
                { NAMESRC: sourceName }
              )}
              {campaignsInUserLists.map((el, i) => (
                <span key={i}>
                  <br />
                  {intl.formatMessage(
                    {
                      id: 'Load.ContentsSouces.DeleteSourceSharedErrorOtherVisibleListDet'
                    },
                    {
                      strong: (str) => <strong>{str}</strong>,
                      LISTA: el.Name,
                      CMP: userListsInCampaigns[i].Name
                    }
                  )}
                </span>
              ))}
            </>
          )}
        </>
      )}

      {campaignsNotInCurrentList.length === 0 && (
        <>
          {relatedCampaigns.Items.length > 1 && // Mostra messaggio di errore se: associato a più campagne della Lista corrente
            intl.formatMessage(
              { id: 'Load.ContentsSouces.DeleteSourceUsedByCampaigns' },
              {
                strong: (str) => <strong>{str}</strong>,
                NAMESRC: sourceName,
                NAMECAM: campaignsNames
              }
            )}
          {relatedCampaigns.Items.length === 1 && // Mostra messaggio di errore se: associato ad una sola campagna della Lista corrente
            intl.formatMessage(
              { id: 'Load.ContentsSouces.DeleteSourceUsedByCampaign' },
              {
                strong: (str) => <strong>{str}</strong>,
                NAMESRC: sourceName,
                NAMECAM: campaignsNames
              }
            )}
        </>
      )}
    </div>
  )
}

export default DeleteWarningMessage

DeleteWarningMessage.propTypes = {
  relatedCampaigns: PropTypes.object,
  userLists: PropTypes.object,
  currentList: PropTypes.number,
  sourceName: PropTypes.string
}
